export default __webpack_public_path__ + "static/media/plus.9d6fb2cf.svg";